var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasErrors) ? _c('alert-box', {
    staticClass: "validation-alert-box",
    attrs: {
      "type": "danger"
    }
  }, [_c('icon', {
    attrs: {
      "name": "bolt"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("\n    " + _vm._s(_vm.$t('validationAlertBox.title')) + "\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "validation-alert-box__errors"
  }, _vm._l((_vm.errors), function(error) {
    return _c('li', {
      staticClass: "validation-alert-box__error"
    }, [_vm._v("\n      " + _vm._s(error) + "\n    ")])
  }))], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e84812ba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ValidationAlertBox.vue
// module id = 2130
// module chunks = 0